import { useFieldArray } from "react-hook-form";
import { Button } from "flowbite-react";
import Input from "../inputs/Input";

const PartnersInputList = ({ control, register }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "company.partners",
  });

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center mb-3 gap-3">
        <div className="font-medium">Sócios / Parceiros</div>
        <button
          className="bg-black rounded-full text-white w-8 h-8"
          onClick={(e) => {
            e.preventDefault(); // ← evita comportamento inesperado
            append({ name: "" }, { shouldFocus: false }); // ← evita o foco e o erro
          }}
        >
          +
        </button>
      </div>

      {fields.map((field, index) => (
        <div key={field.id} className="flex gap-2 items-center mb-2">
          <Input
            register={register}
            name={`company.partners.${index}.name`}
            label={`Nome do sócio #${index + 1}`}
            className="flex-1"
          />
          <Button className="bg-gray-500" onClick={() => remove(index)}>
            Remover
          </Button>
        </div>
      ))}
    </div>
  );
};

export default PartnersInputList;
